export default {
    documentTitle: 'Global Opportunity Platform',

    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',

    loading: 'Loading',
    ok: 'OK',
    save: 'Save',
    add: 'Add',
    close: 'Close',
    delete: 'Delete',
    done: 'Done',

    back: 'Back',
    next: 'Next',
    finish: 'Finish',

    success: 'Success',
    error: 'Error',

    // Is used by the YearMonthPicker-component and should be an array
    months: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ],

    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],

    dialogs: {
        helperTexts: {
            checkHasPendingAction: 'Checking your pending verification',
            verifySchoolConnection:
                'Verify your school connection to access these resources',
            logInToAccessMoreFeatures:
                'Thousands of International Career Opportunities',
        },
    },
    minutesShort: 'min',
};
